'use strict';

function Messages() {

    /********************************/
    // Init messages
    /********************************/
    this.initMessages = function () {
        if ($('.spd_list').find('.forminfree').children().size() === 0) {
            $('.spd_list').replaceWith('<div class="alert alert-warning"><h3>Your search returned too many students, please refine your search criteria.</h3></div>');
        }
    };
}